/**
 * @flow
 * @relayHash 1fe05d00166d9eeda0ed95a25fb86ce6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type homePage_home$ref = any;
export type srcHomePageQueryVariables = {||};
export type srcHomePageQueryResponse = {|
  +home: {|
    +$fragmentRefs: homePage_home$ref
  |}
|};
export type srcHomePageQuery = {|
  variables: srcHomePageQueryVariables,
  response: srcHomePageQueryResponse,
|};
*/


/*
query srcHomePageQuery {
  home {
    ...homePage_home
  }
}

fragment homePage_home on Home {
  headerTitle
  headerSubtitle
  headerPicture
  headerArticle {
    slug
    picture
    city {
      slug
      color
    }
  }
  highlights {
    nomination {
      card_image
      link
      text
      color
    }
  }
  seo {
    title
    description
  }
  social {
    twitter {
      type
      title
      image
      handle
      description
    }
    generic {
      title
      image
      description
    }
  }
  ...featuredSection_home
  ...promotedSection_home
  ...citiesSection_home
  ...featuredStorySection_home
  ...categoriesSection_home
  ...menuSection_home
}

fragment featuredSection_home on Home {
  featuredContent {
    slug
    title
    caption
    readingTime
    picture
    author {
      firstname
      lastname
    }
    city {
      slug
      name
      color
    }
    category {
      slug
      name
      color
    }
  }
}

fragment promotedSection_home on Home {
  promotedContent {
    title
    subtitle
    callToAction
    leftPicture
    rightPicture
  }
}

fragment citiesSection_home on Home {
  cities {
    slug
    name
  }
  citiesContent {
    slug
    title
    caption
    readingTime
    picture
    author {
      firstname
      lastname
    }
    city {
      slug
      name
      color
    }
  }
  citiesPromoted {
    slug
    name
    color
  }
  citiesPromotedPicture
}

fragment featuredStorySection_home on Home {
  featuredStory {
    slug
    title
    caption
    widePicture
    picture
    videoLink
    city {
      slug
      name
      color
    }
    category {
      slug
      name
      color
    }
  }
}

fragment categoriesSection_home on Home {
  categories {
    slug
    name
  }
  categoriesContent {
    slug
    title
    caption
    readingTime
    picture
    author {
      firstname
      lastname
    }
    category {
      slug
      name
      color
    }
  }
  categoriesPromoted {
    slug
    name
    color
  }
  categoriesPromotedPicture
}

fragment menuSection_home on Home {
  menu {
    title
    subtitle
    hoverCaption
    link {
      id
      uid
      type
      slug
      link_type
      url
      target
    }
    color
    picture
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "color",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "caption",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "readingTime",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "Author",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstname",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastname",
      "args": null,
      "storageKey": null
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v11 = [
  v0,
  v10,
  v2
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "city",
  "storageKey": null,
  "args": null,
  "concreteType": "City",
  "plural": false,
  "selections": v11
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "Category",
  "plural": false,
  "selections": v11
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subtitle",
  "args": null,
  "storageKey": null
},
v15 = [
  v0,
  v10
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcHomePageQuery",
  "id": null,
  "text": "query srcHomePageQuery {\n  home {\n    ...homePage_home\n  }\n}\n\nfragment homePage_home on Home {\n  headerTitle\n  headerSubtitle\n  headerPicture\n  headerArticle {\n    slug\n    picture\n    city {\n      slug\n      color\n    }\n  }\n  highlights {\n    nomination {\n      card_image\n      link\n      text\n      color\n    }\n  }\n  seo {\n    title\n    description\n  }\n  social {\n    twitter {\n      type\n      title\n      image\n      handle\n      description\n    }\n    generic {\n      title\n      image\n      description\n    }\n  }\n  ...featuredSection_home\n  ...promotedSection_home\n  ...citiesSection_home\n  ...featuredStorySection_home\n  ...categoriesSection_home\n  ...menuSection_home\n}\n\nfragment featuredSection_home on Home {\n  featuredContent {\n    slug\n    title\n    caption\n    readingTime\n    picture\n    author {\n      firstname\n      lastname\n    }\n    city {\n      slug\n      name\n      color\n    }\n    category {\n      slug\n      name\n      color\n    }\n  }\n}\n\nfragment promotedSection_home on Home {\n  promotedContent {\n    title\n    subtitle\n    callToAction\n    leftPicture\n    rightPicture\n  }\n}\n\nfragment citiesSection_home on Home {\n  cities {\n    slug\n    name\n  }\n  citiesContent {\n    slug\n    title\n    caption\n    readingTime\n    picture\n    author {\n      firstname\n      lastname\n    }\n    city {\n      slug\n      name\n      color\n    }\n  }\n  citiesPromoted {\n    slug\n    name\n    color\n  }\n  citiesPromotedPicture\n}\n\nfragment featuredStorySection_home on Home {\n  featuredStory {\n    slug\n    title\n    caption\n    widePicture\n    picture\n    videoLink\n    city {\n      slug\n      name\n      color\n    }\n    category {\n      slug\n      name\n      color\n    }\n  }\n}\n\nfragment categoriesSection_home on Home {\n  categories {\n    slug\n    name\n  }\n  categoriesContent {\n    slug\n    title\n    caption\n    readingTime\n    picture\n    author {\n      firstname\n      lastname\n    }\n    category {\n      slug\n      name\n      color\n    }\n  }\n  categoriesPromoted {\n    slug\n    name\n    color\n  }\n  categoriesPromotedPicture\n}\n\nfragment menuSection_home on Home {\n  menu {\n    title\n    subtitle\n    hoverCaption\n    link {\n      id\n      uid\n      type\n      slug\n      link_type\n      url\n      target\n    }\n    color\n    picture\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcHomePageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "home",
        "storageKey": null,
        "args": null,
        "concreteType": "Home",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "homePage_home",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcHomePageQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "home",
        "storageKey": null,
        "args": null,
        "concreteType": "Home",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "headerTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "headerSubtitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "headerPicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "headerArticle",
            "storageKey": null,
            "args": null,
            "concreteType": "Article",
            "plural": false,
            "selections": [
              v0,
              v1,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "City",
                "plural": false,
                "selections": [
                  v0,
                  v2
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "highlights",
            "storageKey": null,
            "args": null,
            "concreteType": "Highlights",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "nomination",
                "storageKey": null,
                "args": null,
                "concreteType": "Nominations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "card_image",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "link",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "text",
                    "args": null,
                    "storageKey": null
                  },
                  v2
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seo",
            "storageKey": null,
            "args": null,
            "concreteType": "SEO",
            "plural": false,
            "selections": [
              v3,
              v4
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "social",
            "storageKey": null,
            "args": null,
            "concreteType": "SocialMedia",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "twitter",
                "storageKey": null,
                "args": null,
                "concreteType": "TwtrSlices",
                "plural": true,
                "selections": [
                  v5,
                  v3,
                  v6,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "handle",
                    "args": null,
                    "storageKey": null
                  },
                  v4
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "generic",
                "storageKey": null,
                "args": null,
                "concreteType": "GenSocialSlices",
                "plural": true,
                "selections": [
                  v3,
                  v6,
                  v4
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "featuredContent",
            "storageKey": null,
            "args": null,
            "concreteType": "Article",
            "plural": true,
            "selections": [
              v0,
              v3,
              v7,
              v8,
              v1,
              v9,
              v12,
              v13
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "promotedContent",
            "storageKey": null,
            "args": null,
            "concreteType": "PromotedContent",
            "plural": false,
            "selections": [
              v3,
              v14,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "callToAction",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "leftPicture",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rightPicture",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cities",
            "storageKey": null,
            "args": null,
            "concreteType": "City",
            "plural": true,
            "selections": v15
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "citiesContent",
            "storageKey": null,
            "args": null,
            "concreteType": "Article",
            "plural": true,
            "selections": [
              v0,
              v3,
              v7,
              v8,
              v1,
              v9,
              v12
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "citiesPromoted",
            "storageKey": null,
            "args": null,
            "concreteType": "City",
            "plural": false,
            "selections": v11
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "citiesPromotedPicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "featuredStory",
            "storageKey": null,
            "args": null,
            "concreteType": "Article",
            "plural": false,
            "selections": [
              v0,
              v3,
              v7,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "widePicture",
                "args": null,
                "storageKey": null
              },
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "videoLink",
                "args": null,
                "storageKey": null
              },
              v12,
              v13
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": null,
            "concreteType": "Category",
            "plural": true,
            "selections": v15
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categoriesContent",
            "storageKey": null,
            "args": null,
            "concreteType": "Article",
            "plural": true,
            "selections": [
              v0,
              v3,
              v7,
              v8,
              v1,
              v9,
              v13
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categoriesPromoted",
            "storageKey": null,
            "args": null,
            "concreteType": "Category",
            "plural": false,
            "selections": v11
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "categoriesPromotedPicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "menu",
            "storageKey": null,
            "args": null,
            "concreteType": "Menu",
            "plural": true,
            "selections": [
              v3,
              v14,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hoverCaption",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "link",
                "storageKey": null,
                "args": null,
                "concreteType": "Link",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "uid",
                    "args": null,
                    "storageKey": null
                  },
                  v5,
                  v0,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "link_type",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "target",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              v2,
              v1
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5503472253359502ef8c974a53dc664d';
module.exports = node;
